
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import BlogPage from '../pages/blog/page';
import WhitepaperPage from '../pages/whitepaper/page';
import ClientPortalPage from '../pages/client-portal/page';
import AdminPage from '../pages/admin/page';
import PaymentSuccessPage from '../pages/PaymentSuccess';
import PricingGuidePage from '../pages/pricing-guide/page';
import ROICalculatorPage from '../pages/roi-calculator/page';
import VirtualStagingPage from '../pages/virtual-staging/page';
import LuxuryPropertiesPage from '../pages/luxury-properties/page';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/whitepaper',
    element: <WhitepaperPage />,
  },
  {
    path: '/client-portal',
    element: <ClientPortalPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/payment-success',
    element: <PaymentSuccessPage />,
  },
  {
    path: '/pricing-guide',
    element: <PricingGuidePage />,
  },
  {
    path: '/roi-calculator',
    element: <ROICalculatorPage />,
  },
  {
    path: '/virtual-staging',
    element: <VirtualStagingPage />,
  },
  {
    path: '/luxury-properties',
    element: <LuxuryPropertiesPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
